<template>
  <div class="my_message_class">
    <a-tabs default-active-key="1" :tab-position="tabPosition">
      <a-tab-pane key="1" tab="基本设置">
        <div class="basic_class">
          <span class="basic_title_class">基本设置</span>
          <div class="basic_content_class">
            <span class="basic_text_class">员工编号</span>
            <a-input class="basic_input_class" :value="formData.staffCode" disabled></a-input>
          </div>
          <div class="basic_content_class">
            <span class="basic_text_class">员工姓名</span>
            <a-input class="basic_input_class" :value="formData.staffName" disabled></a-input>
          </div>
          <div class="basic_content_class">
            <span class="basic_text_class">角色</span>
            <a-input class="basic_input_class" :value="formData.roleName" disabled></a-input>
          </div>
          <div class="basic_content_class">
            <span class="basic_text_class">联系电话</span>
            <a-input class="basic_input_class" :value="formData.phone" disabled></a-input>
          </div>
        </div>
      </a-tab-pane>
      <a-tab-pane key="2" tab="账户设置">
        <div class="my_message_class">
          <span class="basic_title_class">账户设置</span>
          <a-form :form="form" class="basic_class">
            <a-form-item
              label="密码"
            >
              <a-input
                v-decorator="['newPassword', { rules: [{ required: true, message: '请输入密码' },{ min: 6, max: 16, message: '密码长度为6-16位', trigger: 'change' }] }]"
                placeholder="请输入密码"
              />
            </a-form-item>
            <a-form-item
              label="确认密码"
            >
              <a-input-password
                v-decorator="['newPassword1', { rules: [{ required: true, message: '请输入确认密码' },{ min: 6, max: 16, message: '密码长度为6-16位', trigger: 'change' }] }]"
                placeholder="请输入确认密码"
              />
            </a-form-item>
          </a-form>
          <div>
            <a-button type="primary" @click="updateHandle">更新账户</a-button>
          </div>
        </div>
        
      </a-tab-pane>
      
    </a-tabs>
  </div>
</template>
<script>
export default {
  data(){
    return{
      tabPosition: 'left',
      formData: {},
      form: this.$form.createForm(this, { }),
    }
  },
  created(){
    this.getUserInfo()
  },
  methods: {
    getUserInfo(){
      // let factoryId = window.localStorage.getItem('factoryId')
      // this.$http.get(`/iot-factory/factorystaff/getStaffInfoByFactoryIdAndUserId?factoryId=${factoryId}`).then(res => {
      // `/iot-user/info`
      let factoryId = window.localStorage.getItem('factoryId')
      this.$http.get(`/iot-factory/factorystaff/getStaffInfoByFactoryIdAndUserId`,{params:{factoryId}}).then(res => {
        let {success,data} = res;
        if(success){
          this.formData = data || {}
        }else{
          this.$message.error('查询失败')
        }
      })
    },
    updateHandle(){
      this.form.validateFields((err, values) => {
        if(err){
          // this.$message.error('请完善数据')
        }else{
          this.$http.post(`/iot-user/update-password-withoutold`,values).then(res => {
            let {success} = res;
            if(success){
              this.$message.success('修改成功')
              // 清除token
              window.localStorage.removeItem("accessToken");
              window.localStorage.removeItem("loginTime");
              window.localStorage.removeItem("refreshToken");
              // 清除登录信息
              window.localStorage.removeItem('factoryId')
              setTimeout(() => {
                this.$router.push("/login");
              }, 0);
            }else{
              this.$message.error('修改失败')
            }
          })
        }
      })
    }
  }
}
</script>
<style lang="scss">
.my_message_class{
  .ant-tabs{
    height: 100%;
  }
}
</style>
<style lang="scss" scoped>
.basic_title_class {
  font-size: 18px;
  font-weight: 700;
  display: inline-block;
  margin-bottom: 12px;
}
  .my_message_class {
    height: calc(100% - 21px);
    background-color: #fff;
    border-radius: 5px;
    padding: 20px;
    .basic_class {
      height: 100%;
      width: 500px;
      .basic_content_class {
        margin-bottom: 20px;
        display: flex;
        flex-direction: column; 
        .basic_text_class {
          margin-bottom: 6px;
          display: inline-block;          
        }
      }
    }
  }
</style>